import {ComputedRef, InjectionKey} from "vue";
import Dictionary from "~/ts/library/Dictionary";

export const TelephonyCallInjectionKey: InjectionKey<ComputedRef<TelephonyCallInjectionKeyInterface>> = Symbol();


export interface TelephonyCallInjectionKeyInterface {
    telephonyCallAuthList: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel[],
    integrationPlatformDictionary: Dictionary<OperatorApplicationApi.OperatorGetParamsPlatformOpenApiModel>,
    makeCall: (phone: string, auth: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel) => void
}